import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useMemo, useState} from "react";
import OrphanContext from "../../../context/orphan/context";
import {ColumnProps} from "antd/lib/table";
import {IOrphan} from "../../../models/orphan/response";
import {ISort, IStaticFilter} from "../../../models/base/base-query";
import {tableOnChange} from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import Space from "../../general/antd/space";
import {Button} from "antd";
import {BarsOutlined} from "@ant-design/icons";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, {EVENT_SUCCESS} from "../../../utils/events";
import AchievementContext from "../../../context/achievement/context";

interface IProps {
   
}

const OrphanTable: React.FC<IProps> = (props) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {list, actions, loading, query} = useContext(AchievementContext);


    const columns: ColumnProps<IOrphan>[] = [
        {
            title: t("id"),
            dataIndex: "id",
            key: "id",
            sorter: true,
            width: 100,
            align: "center",
        },
        {
            title: t("title"),
            dataIndex: "title",
            align: "center",
            key: "title",
            sorter: true,
        },
        {
            title: t("description"),
            dataIndex: "description",
            align: "center",
            key: "description",
            sorter: true,
        },
        {
            title: t("actions"),
            dataIndex: "",
            width: 250,
            fixed: "right",
            align: "center",
            key: "x",
            render: (_: any, record) => (
                <Space>
                    <ViewBtn
                        onClick={async () => {
                            navigate(`details/${record?.id}`);
                        }}
                    />
                    <EditBtn
                        onClick={async () => {
                            navigate(`update/${record?.id}`);
                        }}
                    />
                    <DeleteBtn
                        onConfirm={async () => {
                            await actions.deleteAchievement(record?.id);
                            eventManager.emit(EVENT_SUCCESS);
                        }}
                        loading={loading.includes("delete")}
                    />
                </Space>
            ),
        },
    ];

    let tableFiltersProps = {};
    const [sorts, setSorts] = useState<ISort[]>([]);
    const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

    useEffect(() => {
        sorts.length > 0 &&
        actions.setQuery({
            ...query,
            orders: sorts,
        });
    }, [sorts]);

    return (
        <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list")}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
        />
    )
}
export default OrphanTable;